import {UserModel, userModelListFactory} from "../types/user.model";
import {ProjectModel} from "../project/project.model";
import {projectDetailModelFactory} from "../project/project-detail.model";

export interface DashboardDataModel {
  currentDate?: string;
  TCUsers?: UserModel[];
  toBeDeploySF?: number;
  toBeDeployMF?: number;
  totalDeployedSF?: number;
  totalDeployedMF?: number;
  deployedSFNew?: number;
  deployedMFNew?: number;
  deployedSFMai?: number;
  deployedMFMai?: number;
  totalAssets?: number;
  installed?: number;
  totalRevenue?: number;
  billingStart?: string;
  billingEnd: string;
  monthPlannedDevicesSF?: number;
  monthPlannedDevicesMF?: number;
  q1PlannedDevicesSF?: number;
  q1PlannedDevicesMF?: number;
  q2PlannedDevicesSF?: number;
  q2PlannedDevicesMF?: number;
  forecastFreeze?: any;
  monthPlannedDeployments?: number;
  q1PlannedDeployments?: number;
  q2PlannedDeployments?: number;
  totalBudget?: number;
  totalExpenses?: number;
  totalCustomerValue?: number;
  title?: string;
  project?: ProjectModel;
  deployedToK2PercentageBar?: any;
  pastSchedule?: boolean;
  pastScheduleMessage?: string;
  overBudget?: boolean;
  overBudgetMessage?: string;
  currency?: string;
}

function parseDateFromJSON(date) {
  if (!date) return null;
  const matches = `${date}`.match(/^([0-9]{4}-[0-9]{2}-[0-9]{2})T?/i);
  if (!matches) return null;
  return matches[1] || null;
}

function toNumber(obj): number {
  const f = parseFloat(obj);
  if (Number.isNaN(f)) return 0;
  return f;
}

export function dashboardDataModelFactory(json?: any): DashboardDataModel {
  json = json || {};

  return {
    currentDate: parseDateFromJSON(json.currentDate) || "",
    TCUsers: userModelListFactory(json.TCUsers),
    toBeDeploySF: toNumber(json.toBeDeploySF),
    toBeDeployMF: toNumber(json.toBeDeployMF),
    totalDeployedSF: toNumber(json.totalDeployedSF),
    totalDeployedMF: toNumber(json.totalDeployedMF),
    deployedSFNew: toNumber(json.deployedSFNew),
    deployedMFNew: toNumber(json.deployedMFNew),
    deployedSFMai: toNumber(json.deployedSFMai),
    deployedMFMai: toNumber(json.deployedMFMai),
    totalAssets: toNumber(json.totalAssets),
    installed: toNumber(json.installed),
    totalRevenue: toNumber(json.totalRevenue),
    billingStart: json.billingStart,
    billingEnd: json.billingEnd,
    monthPlannedDevicesSF: toNumber(json.monthPlannedDevicesSF),
    monthPlannedDevicesMF: toNumber(json.monthPlannedDevicesMF),
    q1PlannedDevicesSF: toNumber(json.q1PlannedDevicesSF),
    q1PlannedDevicesMF: toNumber(json.q1PlannedDevicesMF),
    q2PlannedDevicesSF: toNumber(json.q2PlannedDevicesSF),
    q2PlannedDevicesMF: toNumber(json.q2PlannedDevicesMF),
    forecastFreeze: json.forecastFreeze,
    monthPlannedDeployments: toNumber(json.monthPlannedDeployments),
    q1PlannedDeployments: toNumber(json.q1PlannedDeployments),
    q2PlannedDeployments: toNumber(json.q2PlannedDeployments),
    deployedToK2PercentageBar: json.deployedToK2PercentageBar || {},
    pastSchedule: json.pastSchedule,
    pastScheduleMessage: json.pastScheduleMessage,
    overBudget: json.overBudget,
    overBudgetMessage: json.overBudgetMessage,
    totalCustomerValue: toNumber(json.totalCustomerValue),
    totalExpenses: toNumber(json.totalExpenses),
    totalBudget: toNumber(json.totalBudget),
    currency: json.currency,
    title: json.title || "",
    project: projectDetailModelFactory(json.project),
  } as DashboardDataModel;
}
